const styles = () => ({
  dialogPaper: {
    alignItems: 'center',
    textAlign: 'center',
    overflowX: 'hidden',
  },

  dialogContentRoot: {
    maxWidth: 340,
    marginTop: 24,
    '& p': {
      color: '#148cfc',
      fontWeight: 500,
      marginBottom: 0,
    },
  },

  dialogActionsRoot: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    '& button': {
      margin: 0,
    },
  },

  dialogContentColumns: {
    width: 780,
  },

  dialogActionsColumns: {
    justifyContent: 'flex-end',
    zIndex: 0,
    width: '100%',
    '& button': {
      marginLeft: 20,
    },
  },
});

export default styles;
